import ClientPostPaymentFormButton from './ClientPostPaymentFormButton';

export default ClientPostPaymentFormButton;
